"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Card_1 = __importDefault(require("../components/Card"));
const CardCaption_1 = __importDefault(require("../components/CardCaption"));
const CardContainer_1 = __importDefault(require("../components/CardContainer"));
const Text_1 = __importDefault(require("../components/Text"));
const styles_1 = require("../styles");
const ButtonBase_1 = __importDefault(require("./ButtonBase"));
var backPattern = require('../../assets/backPattern.jpg');
const ImageButton = ({ testID, numberOfColumns = 3, name, captionColor = 'default', image = {}, svg, linkUrl, style, captionHeight = 'small', onPress, children, screenName, params, disabled = false, }) => {
    return (react_1.default.createElement(react_native_1.View, { testID: testID, style: { flex: 1 / numberOfColumns } },
        react_1.default.createElement(Card_1.default, { style: react_native_1.StyleSheet.flatten([{ margin: styles_1.getSpacing(0.5) }, style]) },
            react_1.default.createElement(ButtonBase_1.default, { to: linkUrl, screenName: screenName, params: params, onPress: onPress, disabled: disabled },
                react_1.default.createElement(CardContainer_1.default, { style: styles.cardContainer },
                    !svg && (react_1.default.createElement(react_native_1.Image, { resizeMode: "contain", defaultSource: backPattern, source: image, style: react_native_1.StyleSheet.flatten([styles.image, { alignSelf: 'center' }]) })),
                    svg),
                !!name && (react_1.default.createElement(CardCaption_1.default, { color: disabled ? 'lightGray' : captionColor, height: captionHeight },
                    react_1.default.createElement(Text_1.default, { numberOfLines: 1, variant: "mediumBody", color: disabled ? 'disabled' : 'primary', margin: "none", style: styles.text }, name))),
                children))));
};
exports.default = ImageButton;
const styles = react_native_1.StyleSheet.create({
    cardContainer: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    image: {
        height: 70,
        width: 70,
    },
    text: { textAlign: 'center' },
});
